import { createSlice } from '@reduxjs/toolkit';

const NAME = 'toast';
const INITIAL_STATE = null;

const toastReducer = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        success: (state, action) => {
            return {
                ...state,
                message: action.payload,
                className: 'is-success'
            };
        },
        error: (state, action) => {
            return {
                ...state,
                message: action.payload,
                className: 'is-danger'
            };
        },
        clear: () => {
            return INITIAL_STATE;
        }
    }
});

export const { success, error, clear } = toastReducer.actions;
export const selectToast = (state) => state.toast;
export default toastReducer.reducer;
